export default __webpack_public_path__ + "d71eb654c8fc7aa11584d1e2bae71e16.png";